import { ColorInput as CompassColorInput } from "@circleco/compass/components/ColorInput";
import type { ReactNode } from "react";
import { Controller, useFormContext } from "react-hook-form";

const normalizeHex = (value: string | undefined): string | undefined => {
  if (!value) return undefined;
  return value.startsWith("#") ? value : `#${value}`;
};

export interface ColorPickerProps {
  description?: ReactNode;
  disabled?: boolean;
  error?: string;
  invalid?: boolean;
  label?: ReactNode;
  labelTooltip?: string;
  layout?: "horizontal" | "vertical";
  name: string;
  rootProps?: Record<string, unknown>;
  supportTransparency?: boolean;
}

export const ColorPicker = ({
  name,
  disabled = false,
  supportTransparency = false,
  label,
  description,
  error,
  invalid,
  layout,
  labelTooltip,
  rootProps: rootPropsFromProps,
}: ColorPickerProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange } }) => {
        const normalizedValue = normalizeHex(value);
        return (
          <CompassColorInput
            defaultValue={normalizedValue}
            value={normalizedValue}
            onChange={onChange}
            disabled={disabled}
            supportTransparency={supportTransparency}
            label={label}
            description={description}
            error={error}
            invalid={invalid}
            layout={layout}
            labelTooltip={labelTooltip}
            rootProps={rootPropsFromProps}
          />
        );
      }}
    />
  );
};

ColorPicker.displayName = "Form.ColorPicker";
